/**
 * ScamBlocker AI — Auth Layout
 * Split-screen: sol taraf brand görseli, sağ taraf form.
 */

import { Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import styles from './AuthLayout.module.css';

export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className={styles.layout}>
      {/* Brand Panel */}
      <div className={styles.brand}>
        <div className={styles.brandContent}>
          <Shield size={48} className={styles.brandIcon} />
          <h1 className={styles.brandTitle}>ScamBlocker AI</h1>
          <p className={styles.brandSubtitle}>
            {t('authLayout.subtitleLine1')}
            <br />
            {t('authLayout.subtitleLine2')}
          </p>
          <div className={styles.brandStats}>
            <div className={styles.stat}>
              <span className={styles.statNumber}>99.7%</span>
              <span className={styles.statLabel}>{t('authLayout.statDetectionAccuracy')}</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statNumber}>&lt;200ms</span>
              <span className={styles.statLabel}>{t('authLayout.statAnalysisTime')}</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statNumber}>7/24</span>
              <span className={styles.statLabel}>{t('authLayout.statLiveMonitoring')}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Form Panel */}
      <div className={styles.form}>
        <div className={styles.formContent}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
